import { Component, OnInit, Inject } from '@angular/core';
import { environment, ConstVariable } from 'src/environments/environment';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule } from '@angular/forms';
import { HttpEventType, HttpClient, HttpHeaders } from "@angular/common/http";
import { LookupInfo } from '../../model/lookup.model';
import { GlobalService } from '../../service/global.service';
import { TokenService } from '../../service/token.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OrganizationDOA } from '../../model/OrganizationDOA.model';
import { OrganizationManagement } from '../../model/OrganizationManagement.model';
import { DivisionInfo } from '../../model/division.model';
import { DepartmentInfo } from '../../model/department.model';
import { SectionInfo } from '../../model/SectionInfo.model';
import { UnitInfo } from '../../model/UnitInfo.model';
import { PositionLevelInfo } from '../../model/PositionManagementInfo.model';
import { ActionInfo } from '../../model/ActionInfo.model';
import { CompanyInfo } from '../../model/company.model';

@Component({
  selector: 'app-doa-mapping',
  templateUrl: './doa-mapping.component.html',
  styleUrls: ['./doa-mapping.component.css']
})
export class DoaMappingComponent implements OnInit {
  /************************* Variables ************************** */
  baseurl: string;
  _EmpCode: string;
  _ParamWFType: string;
  _ParamWFTypeName: string;
  _ParamGroupCode: string;

  //Master Model
  ListStatus: LookupInfo[] = [];
  ListWorkflowType: LookupInfo[] = [];
  ListDOAMappingManagement: OrganizationDOA[] = [];
  organizationDoaInfo: OrganizationDOA = new OrganizationDOA;
  organizationInfo: OrganizationManagement = new OrganizationManagement;

  //List Organization management
  ListCompany: CompanyInfo[] = [];
  ListDivision: DivisionInfo[] = [];
  ListDepartment: DepartmentInfo[] = [];
  ListSection: SectionInfo[] = [];
  ListUnit: UnitInfo[] = [];
  ListPositionLevel: PositionLevelInfo[] = [];
  ListActions: ActionInfo[] = [];

  //Search
  isSearchSubmitted: boolean = false;
  txtSchOrganizationCode: string;
  txtSchGroupDOACode: string;
  ddlSchMasterStatus: string = "";

  //Form variable
  doaMappingForm: FormGroup;
  organizationMappingForm: FormGroup;
  IsDuplicateCode: boolean;

  //Pagination
  indexNo: number = 0;
  currentPageNumber: number = 1;
  totalMaster: number = 0;
  totalPages: number = 0;
  pageSize: number;

  //Loading
  displayloading: boolean = false;
  Msgloadding: string = '';

  //Modal
  titlemodal: string;
  detailmodal: string;


  /************************* End Variables ************************** */
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService, private router: Router, private activatedRouter: ActivatedRoute) {
    this.baseurl = environment.base_api;
  }

  ngOnInit() {
    //Set param
    this.activatedRouter.params.subscribe(params => {
      this._ParamWFType = params['wf'];
      this._ParamGroupCode = params['groupcode'];
    });

    //Init data
    this.currentPageNumber = 1;
    this.pageSize = environment.PageSizeMedium;
    this._EmpCode = localStorage.getItem("EmpCode");
    this.ddlSchMasterStatus = 'Y'

    //Load init data
    this.LoadLookupType("MASTERSTATUS").then((data) => {
      this.ListStatus = data;
    });
    this.LoadLookupType("WORKFLOWTYPE").then((data) => {
      this.ListWorkflowType = data;
      var filterred = data.filter(x => { return x.LookupCode == this._ParamWFType });
      this._ParamWFTypeName = filterred[0].LookupValue;
    });

    this.LoadMasterList('GetDOAActionList').then((data) => {
      this.ListActions = data;
    });
    this.LoadCompanyList().then((data) => {
      this.ListCompany = data;
    });
    this.LoadMasterList('GetDivisionList').then((data) => {
      this.ListDivision = data;
    });
    this.LoadMasterList('GetDepartmentList').then((data) => {
      this.ListDepartment = data;
    });
    this.LoadMasterList('GetSectionList').then((data) => {
      this.ListSection = data;
    });
    this.LoadMasterList('GetUnitList').then((data) => {
      this.ListUnit = data;
    });
    this.LoadPositionLevelList().then((data) => {
      this.ListPositionLevel = data;
    });

    this.LoadDOAMappingList().then((data) => {
      this.ListDOAMappingManagement = data;
    });
    this.LoadCountMasterList();

    //Declare form
    this.doaMappingForm = new FormGroup({
      WorkflowType: new FormControl(this.organizationDoaInfo.WorkflowType, [Validators.required]),
      GroupCodeDOA: new FormControl(this.organizationDoaInfo.GroupCodeDOA, [Validators.required]),
      OrganizationCode: new FormControl(this.organizationDoaInfo.OrganizationCode),
      MaxPositionLevel: new FormControl(this.organizationDoaInfo.MaxPositionLevel),
      ActionId: new FormControl(this.organizationDoaInfo.ActionId, [Validators.required]),
      SequenceApprove: new FormControl(this.organizationDoaInfo.SequenceApprove, [Validators.required]),
      FlagActive: new FormControl(this.organizationDoaInfo.FlagActive)
    });
    this.organizationMappingForm = new FormGroup({
      Company: new FormControl(this.organizationInfo.CompanyCode, [Validators.required]),
      Division: new FormControl(this.organizationInfo.DivisionCode),
      Department: new FormControl(this.organizationInfo.DepartmentCode),
      Section: new FormControl(this.organizationInfo.SectionCode),
      Unit: new FormControl(this.organizationInfo.UnitCode),
      PositionLevel: new FormControl(this.organizationInfo.OrganizationLevel, [Validators.required])
    });
  }

  get Company() { return this.organizationMappingForm.get('Company'); }
  get Division() { return this.organizationMappingForm.get('Division'); }
  get Department() { return this.organizationMappingForm.get('Department'); }
  get Section() { return this.organizationMappingForm.get('Section'); }
  get Unit() { return this.organizationMappingForm.get('Unit'); }
  get PositionLevel() { return this.organizationMappingForm.get('PositionLevel'); }

  get WorkflowType() { return this.doaMappingForm.get('WorkflowType'); }
  get GroupCodeDOA() { return this.doaMappingForm.get('GroupCodeDOA'); }
  get OrganizationCode() { return this.doaMappingForm.get('OrganizationCode'); }
  get MaxPositionLevel() { return this.doaMappingForm.get('MaxPositionLevel'); }
  get ActionId() { return this.doaMappingForm.get('ActionId'); }
  get SequenceApprove() { return this.doaMappingForm.get('SequenceApprove'); }
  get FlagActive() { return this.doaMappingForm.get('FlagActive'); }

  async LoadLookupType(LookupType) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LookupType'] = LookupType;
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise();
    }
  }
  async LoadDOAMappingList(dataId: number = 0): Promise<OrganizationDOA[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSizeMedium;
      var objectjson = {};
      objectjson['Id'] = dataId;
      objectjson['WorkflowType'] = this._ParamWFType;
      objectjson['GroupCodeDOA'] = this._ParamGroupCode;
      objectjson['OrganizationCode'] = this.txtSchOrganizationCode;
      objectjson['FlagActive'] = $('#ddlSchMasterStatus').val();
      objectjson['rowFetch'] = environment.PageSizeMedium;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<OrganizationDOA[]>(this.baseurl + "DOAMapping/GetMappingDOAList", strjson, httpOptions)
        .toPromise()
    }
  }
  async LoadCountMasterList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['WorkflowType'] = this._ParamWFType;
      objectjson['GroupCodeDOA'] = this._ParamGroupCode;
      objectjson['OrganizationCode'] = this.txtSchOrganizationCode;
      objectjson['FlagActive'] = $('#ddlSchMasterStatus').val();
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      this.httpClient.post<number>(this.baseurl + "DOAMapping/GetCountMappingDOAList", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SetTotalpagePagination(data);
        });
    }
  }
  async LoadCompanyList(): Promise<CompanyInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<CompanyInfo[]>(this.baseurl + "Company/GetCompany", strjson, httpOptions)
        .toPromise();
    }
  }
  async LoadPositionLevelList(dataId: number = 0): Promise<PositionLevelInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSizeMedium;
      var objectjson = {};
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<PositionLevelInfo[]>(this.baseurl + "Position/GetPositionLevelList", strjson, httpOptions)
        .toPromise()
    }
  }
  async LoadMasterList(masterUrl): Promise<any[]>{
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<any>(this.baseurl + "DOAMapping/" + masterUrl, strjson, httpOptions)
        .toPromise();
    }
  }
  
  OnSearch_Click() {
    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.isSearchSubmitted = true;
    this.LoadDOAMappingList().then((data) => {
      this.ListDOAMappingManagement = data;
    });
  }
  OnClear_Click() {
    this.txtSchGroupDOACode = null;
    this.txtSchOrganizationCode = null;
    $('#ddlSchMasterStatus').val('')

    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.isSearchSubmitted = false;
    this.LoadDOAMappingList().then((data) => {
      this.ListDOAMappingManagement = data;
    });
  }

  //Create btn
  OnCreateMaster_Click() {

    $('#modalCreateMasterTitle').html('Create Master DOA');
    $('#modalCreateOrEditMaster').modal();
    this.organizationDoaInfo = new OrganizationDOA;
    this.organizationInfo = new OrganizationManagement;
    
    this.doaMappingForm.markAsUntouched();
    this.doaMappingForm.markAsPristine();

    this.organizationMappingForm.markAsUntouched();
    this.organizationMappingForm.markAsPristine();
  }
  OnDdl_Change(nextEnableCtrl) {

    var orgCode = "";
    orgCode += this.Company.value;
    orgCode += !!this.Division.value && this.Division.value != "Please select" ? this.Division.value : '';
    orgCode += !!this.Department.value && this.Department.value != "Please select" ? this.Department.value : '';
    orgCode += !!this.Section.value && this.Section.value != "Please select" ? this.Section.value : '';
    orgCode += !!this.Unit.value && this.Unit.value != "Please select"? this.Unit.value : '';

    this.OrganizationCode.setValue(orgCode);

    //var isEnable = false;
    //!!this.Company.value && this.Company.value != "Please select" ? isEnable = false : isEnable = true; 
    //!!this.Division.value && this.Division.value != "Please select" ? isEnable = false : isEnable = true;
    //!!this.Department.value && this.Department.value != "Please select" ? isEnable = false : isEnable = true;
    //!!this.Section.value && this.Section.value != "Please select" ? isEnable = false : isEnable = true;
    //!!this.Unit.value && this.Unit.value != "Please select" ? isEnable = false : isEnable = true;

    if (!!nextEnableCtrl) {
      $('#' + nextEnableCtrl).prop('disabled', false);
    }
  }

  async OnSubmitCreateMaster_Click() {
    if (this.doaMappingForm.valid && !this.IsDuplicateCode) {

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = this.doaMappingForm.value;

        objectjson['WorkflowType'] = this.doaMappingForm.get('WorkflowType').value;
        objectjson['GroupCodeDOA'] = this.doaMappingForm.get('MasterCode').value;
        objectjson['DOAName'] = this.doaMappingForm.get('MasterName').value;
        objectjson['FlagActive'] = this.doaMappingForm.get('MasterStatus').value;
        objectjson['CreateBy'] = this._EmpCode;

        let strjson = JSON.stringify(objectjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "DOAMapping/InsertMasterDOA", strjson, httpOptions)
          .toPromise().then((data) => {
            this.titlemodal = '';
            this.detailmodal = 'Position level has been created successfully.';
            $('#ModalComplate .modal-header').text('Information');
            $('#ModalComplate .modal-header').addClass('bg-gold');
            $('#ModalComplate').modal();
            $('#modalCreateOrEditMaster').modal('hide');

            //Reload
            this.LoadDOAMappingList().then((data) => {
              this.ListDOAMappingManagement = data;
            });
            this.LoadCountMasterList();
          });
      }
    } else {
      this.markFormGroupTouched(this.doaMappingForm);
    }

  }
  async OnEdit_Click(masterId) {

    if (!!masterId) {
      
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.LoadDOAMappingList(masterId).then((data) => {

          //this.organizationDoaInfo = data[0];
          //this.MasterCode.setValue(data[0].GroupCodeDOA);
          // this.MasterName.setValue(data[0].DOAName);
          this.WorkflowType.setValue(data[0].WorkflowType);

          setTimeout(() => {

            $('#modalCreateMasterTitle').html('Edit Master DOA');
            $('#modalCreateOrEditMaster').modal();
          }, 500);
        });
      }
    }
  }
  async OnSubmitEdit_Click() {
    if (this.doaMappingForm.valid && !this.IsDuplicateCode) {

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        //ปรับ flag ก่อนนำไป save ลง DB
        var objectjson = this.doaMappingForm.value;
        objectjson['GroupCodeDOA'] = this.doaMappingForm.get('MasterCode').value;
        objectjson['DOAName'] = this.doaMappingForm.get('MasterName').value;
        objectjson['FlagActive'] = this.doaMappingForm.get('MasterStatus').value;

        objectjson['UpdateBy'] = this._EmpCode;
        objectjson['Id'] = this.organizationDoaInfo.Id;


        let strjson = JSON.stringify(objectjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "DOAMapping/UpdatePositionLevelManagement", strjson, httpOptions)
          .toPromise().then((data) => {
            if (!!data) {
              this.titlemodal = '';
              this.detailmodal = 'Position level has been updated successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();
              $('#modalCreateOrEditMaster').modal('hide');

              //Reload
              this.LoadDOAMappingList().then((data) => {
                this.ListDOAMappingManagement = data;
              });
            } else {
              this.titlemodal = 'Fail.';
              this.detailmodal = 'Position was updated fail.';
              $('#ModalError').modal();
              $('#modalCreateOrEditMaster').modal('hide');

            }
          });
      }
    } else {
      this.markFormGroupTouched(this.doaMappingForm);
    }
  }
  async OnDelete_Click(masterId) {
    if (!!masterId) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = this.doaMappingForm.value;
        objectjson['UpdateBy'] = this._EmpCode;
        objectjson['Id'] = masterId;

        let arrjson: OrganizationDOA[] = [];
        arrjson.push(objectjson);
        let strjson = JSON.stringify(arrjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "DOAMapping/DeletePositionLevelManagement", strjson, httpOptions)
          .toPromise().then((data) => {
            if (!!data) {
              this.isSearchSubmitted = false;
              this.titlemodal = '';
              this.detailmodal = 'Position level has been deleted successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();

              //Reload
              this.LoadDOAMappingList().then((data) => {
                this.ListDOAMappingManagement = data;
              });

            }
            else {

              this.titlemodal = 'Fail.';
              this.detailmodal = 'Delete fail.';
              $('#ModalError').modal();

            }
          });
      }
    }
  }
  async OnDeleteList_Click() {
    var listDeleteChecked = $('[name="checkboxdelete"]:checked');
    let arrjson: OrganizationDOA[] = [];

    //เก็บ List id ที่จะ delete
    $.each(listDeleteChecked, function (idx, val) {
      var curId = $(val).data('positionid');
      var model = new OrganizationDOA;
      model.Id = curId;
      arrjson.push(model);
    });

    if (arrjson.length > 0) {
      if (confirm("Are you sure to delete these DOA?")) {
        var auth_token = await this.TokenService.RefreshToken();
        if (!!auth_token) {
          //ส่งไป Delete
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };
          let strjson = JSON.stringify(arrjson);

          console.log(strjson);

          this.httpClient.post<any>(this.baseurl + "DOAMapping/DeletePositionLevelManagement", strjson, httpOptions)
            .toPromise().then((data) => {
              if (!!data) {

                this.titlemodal = '';
                this.detailmodal = 'Position levels have been deleted successfully.';
                $('#ModalComplate .modal-header').text('Information');
                $('#ModalComplate .modal-header').addClass('bg-gold');
                $('#ModalComplate').modal();

                setTimeout(() => {
                  this.isSearchSubmitted = false;
                  //Reload
                  this.LoadDOAMappingList().then((data) => {
                    this.ListDOAMappingManagement = data;
                  });
                  this.LoadCountMasterList()
                }, 500);


              }
              else {

                this.titlemodal = 'Fail.';
                this.detailmodal = 'Delete fail.';
                $('#ModalError').modal();

              }
            });
        }
      }
    } else {

      this.titlemodal = 'Fail.';
      this.detailmodal = 'Please select DOA to delete at lease 1 row.';
      $('#ModalError .modal-header').text("Sorry");
      $('#ModalError').modal();
    }
  }


  //Name position clicked
  async OnAddRights_Click(positionId) {
    if (!!positionId) {

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.LoadDOAMappingList(positionId).then((data) => {

          //this.organizationDoaInfo = data[0];
          //this.MasterCode.setValue(data[0].GroupCodeDOA);
          //this.MasterName.setValue(data[0].DOAName);
          //this.WorkflowType.setValue(data[0].WorkflowType);

          setTimeout(() => {

            $('#modalCreateMasterTitle').html('Edit position level');
            $('#modalCreateOrEditMaster').modal();
          }, 500);
        });
      }
    }
  }
  async CheckDuplicateCode() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['WorkflowType'] = this.WorkflowType.value;
      //objectjson['GroupCodeDOA'] = this.MasterCode.value;
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      this.httpClient.post<boolean>(this.baseurl + "DOAMapping/CheckDuplicateGroupApproverCode", strjson, httpOptions)
        .toPromise()
        .then(data => {

          this.IsDuplicateCode = data;

        })
        .catch(err => {

          this.IsDuplicateCode = false;

        });
    }
  }

  //Pagination
  OnLoadListFinished(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber = traget.currentPageNumber;
      this.totalPages = traget.totalPages;
      this.indexNo = traget.index;
    }

    this.LoadDOAMappingList().then((data) => {
      this.ListDOAMappingManagement = data;
    });;
  }
  SetTotalpagePagination(data) {
    this.totalMaster = data;
    if (this.totalMaster == 0) {
      this.currentPageNumber = 0;
    }
    this.totalPages = Math.ceil(this.totalMaster / environment.PageSizeMedium);
  }

  //Private function
  private Loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }
  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();


      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
}
